import { render, staticRenderFns } from "./LiveCourseList.vue?vue&type=template&id=9eddabe2&"
import script from "./liveCourseList.js?vue&type=script&lang=js&"
export * from "./liveCourseList.js?vue&type=script&lang=js&"
import style0 from "./liveCourseList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports